import { Injectable } from '@angular/core';
import {
  AbstractGraphqlRequest,
  GraphqlRequestType,
  ItemNotFound,
} from '@ckmk/angular';
import { TypedDocumentNode } from '@apollo/client';
import { PostModel } from '@app/src/app/modules/post/classes/default/model/post.model';
import { gql } from 'apollo-angular';

@Injectable({
  providedIn: 'root',
})
export class PostByRequestQuery extends AbstractGraphqlRequest<
  PostModel | ItemNotFound
> {
  protected override type: GraphqlRequestType = 'query';

  protected override getQuery(): TypedDocumentNode<any, any> {
    return gql`
      query findOnePostBy($payload: PostRequestPayloadInput) {
        findOnePostBy(payload: $payload) {
          category {
            title
            description
          }
          cover {
            name
            extension
            directory
            directories
            frontUrls
            mimetype
          }
          picture {
            name
            extension
            directory
            directories
            frontUrls
            mimetype
          }
          pictures {
            name
            extension
            directory
            directories
            frontUrls
            mimetype
          }
          slug
          title
          description
          shortDescription
          active
          createdAt
          updatedAt
          createdBy
          updatedBy
        }
      }
    `;
  }

  protected override onParseResult(data: any, payload?: any) {
    let item = data.findOnePostBy;

    if (item) {
      return new PostModel(item);
    }

    return new ItemNotFound();
  }
}
